// Libellés des catégories produits.
// ⚠️ Doit rester aligné avec PRODUCT_CATEGORIES dans backend/category_rules.py.
// Utilisés là où la liste de l'API n'est pas chargée, par exemple le badge
// d'une carte produit : sans cela, on afficherait le code brut ("dry_goods").
// Rayon transversal composé à la volée (sélection du commerçant + meilleures
// ventes) : aucun produit n'y est rangé, il ne doit pas être proposé comme
// catégorie dans le back-office. Voir backend/everyday.py.
export const EVERYDAY_CATEGORY_ID = 'quotidien';

export const CATEGORY_LABELS = {
  quotidien: { fr: 'Produits du quotidien', en: 'Everyday essentials' },
  fish: { fr: 'Poissons & fruits de mer', en: 'Fish & Seafood' },
  chicken: { fr: 'Poulet & volaille', en: 'Chicken & Poultry' },
  meat: { fr: 'Viandes & abats', en: 'Meat & Offal' },
  vegetables: { fr: 'Légumes & feuilles', en: 'Vegetables & Leaves' },
  fruits: { fr: 'Fruits', en: 'Fruits' },
  rice: { fr: 'Riz & céréales', en: 'Rice & Cereals' },
  flour: { fr: 'Farines & fufu', en: 'Flours & Fufu' },
  legumes: { fr: 'Légumineuses', en: 'Pulses & Beans' },
  condiments: { fr: 'Épices & herbes', en: 'Spices & Herbs' },
  bouillons: { fr: 'Bouillons & assaisonnements', en: 'Stock Cubes & Seasonings' },
  sauces: { fr: 'Sauces & pâtes', en: 'Sauces & Pastes' },
  canned: { fr: 'Conserves', en: 'Canned Goods' },
  oils: { fr: 'Huiles', en: 'Oils' },
  beverages: { fr: 'Boissons', en: 'Beverages' },
  dairy: { fr: 'Produits laitiers & petit-déjeuner', en: 'Dairy & Breakfast' },
  snacks: { fr: 'Snacks & nouilles', en: 'Snacks & Noodles' },
  samosas: { fr: 'Samoussas & apéritifs', en: 'Samosas & Appetizers' },
  frozen: { fr: 'Surgelés préparés', en: 'Prepared Frozen' },
};

export function getCategoryLabel(categoryId, language = 'fr') {
  const entry = CATEGORY_LABELS[categoryId];
  if (!entry) return categoryId; // catégorie inconnue : on affiche le code tel quel
  return entry[language] || entry.fr;
}
